import {
    Component, EventEmitter, Input, OnInit, Output,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import { OverlayContext } from 'ngx-modialog';
import { ClientModel } from '../../../../../shared/models/client.model';
import { SubscriptionModel } from '../../../../../shared/models/subscription.model';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CommonHttpService } from '../../../../../shared/services/http.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Response } from '@angular/http';

@Component({
    selector: 'account-subscriptions-details-actions-pause',
    templateUrl: './account.subscriptions.details.actions.pause.component.html',
    styleUrls: ['./../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsActionsPauseComponent implements OnInit {
    @ViewChild('templateRef') public templateRef: TemplateRef<any>;
    @Input('client') client: ClientModel;
    @Input('subscription') subscription: SubscriptionModel;
    @Output('loading') loading: EventEmitter<null> = new EventEmitter();
    @Output('updated') updated: EventEmitter<null> = new EventEmitter();
    @Output('failed') failed: EventEmitter<null> = new EventEmitter();

    public reason: FormControl;
    public cycles: FormControl;
    public pauseCyclesLimit: number;
    protected overlayContext = new OverlayContext();
    private pauseForm: FormGroup;

    constructor(
        protected modal: Modal,
        protected http: CommonHttpService,
        protected translate: TranslateService,
        protected toastr: ToastrService
    ) {
        this.overlayContext.inElement = false;
        this.overlayContext.isBlocking = true;
        this.overlayContext.keyboard = null;
    }

    ngOnInit() {
        this.pauseCyclesLimit = this.subscription.plan.pause_cycles_limit || 999;
        this.reason = new FormControl('', Validators.required);
        this.cycles = new FormControl('', [
            Validators.required,
            Validators.min(1),
            Validators.max(this.pauseCyclesLimit)
        ]);
        this.pauseForm = new FormGroup({
            reason: this.reason,
            cycles: this.cycles
        });
    }

    /**
     * Open pause dialog to input pause data.
     **/
    public openPauseDialog() {
        this.modal
            .open(this.templateRef, {context: this.overlayContext})
            .then();
    }

    /**
     * Validate and call API to pause subscription and update subscription data.
     **/
    public pause() {
        if (!this.pauseForm.valid) {
            this.translate
                .get(
                    'ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.PAUSE_MODAL.VALIDATION_ERROR',
                    {pauseCyclesLimit: this.pauseCyclesLimit}
                )
                .subscribe(message => this.toastr.error(message));
            return;
        }

        this.loading.emit();
        this.triggerPause();
    }

    /**
     * Call API to perform pause.
     **/
    private triggerPause() {
        this.translate.get([
            'ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.PAUSE_MODAL.SUCCESS',
            'ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.PAUSE_MODAL.ERROR'
        ]).subscribe(translated => {
            this.http.useAuth().post(
                `/account/clients/${this.client.id}`
                + `/subscriptions/${this.subscription.id}`
                + `/pause`,
                {
                    reason: this.reason.value,
                    cycles: this.cycles.value
                }
            )
            .subscribe(() => {
                this.updated.emit();
                this.toastr.success(translated['ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.PAUSE_MODAL.SUCCESS']);
                this.modal.overlay.closeAll();
            }, (error: Response) => {
                let errorMessage = translated['ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.PAUSE_MODAL.ERROR'];
                if (error.status === 422) {
                    errorMessage = error.json().message;
                }

                this.failed.emit();
                this.toastr.error(errorMessage);
            });
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/account/subscriptions/details/actions/pause/account.subscriptions.details.actions.pause.component.ts